import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { LabButton } from "./LabButton";
import { IMAGES } from "../data/site";
import { revealUp, staggerParent, viewportOnce } from "../lib/motion";

export const StoryTeaser = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="story-section"
      className="bg-charcoal"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 md:grid-cols-2">
        {/* Image (parallax) */}
        <div className="relative h-[420px] overflow-hidden md:h-[720px]">
          <motion.img
            src={IMAGES.story}
            alt="Chicken mid-fry in the kitchen"
            style={{ y: imgY }}
            loading="lazy"
            decoding="async"
            className="absolute inset-0 -top-[12%] h-[124%] w-full object-cover"
          />
          <div className="absolute inset-0 bg-charcoal/25" />
        </div>

        {/* Copy */}
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="flex flex-col justify-center px-5 py-16 sm:px-14 sm:py-24"
        >
          <motion.p variants={revealUp} className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-labyellow">
            04 / OUR STORY
          </motion.p>
          <motion.h2
            variants={revealUp}
            className="font-display text-3xl leading-[1.08] tracking-tight text-labyellow sm:text-5xl"
          >
            PRECISION IN THE KITCHEN. ART ON THE PLATE.
          </motion.h2>
          <motion.p
            variants={revealUp}
            className="mt-6 max-w-lg font-body text-base leading-relaxed text-offwhite/80"
          >
            Chicken Labb was founded in New Jersey to redefine the craft of chicken with absolute
            discipline. We don&apos;t just pick the best ingredients — we combine them in
            exact balance, with flawless technique and precision measured to the millimeter.
          </motion.p>
          <motion.div variants={revealUp} className="mt-9">
            <LabButton to="/story" variant="ghostYellow" testId="read-full-story-button">
              Read the Full Story
            </LabButton>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
